import type { UserResponse } from "~types/user";
import type { UserTransformed } from "../types";
import transformUserPermission from "./transformUserPermission";

const transformPermissionUserDetailsResponse = (response: UserResponse): UserTransformed => {
  const user = response.data[0];

  if (!user) {
    console.error("User details response is empty");
    return {} as UserTransformed;
  }

  const resources = response?.includes?.resources || {};

  return {
    ...user,
    permissions: [
      ...user.userBasedPermissions.map((permission) => transformUserPermission(permission, false, resources)),
      ...user.roleBasedPermissions.map((permission) => transformUserPermission(permission, true, resources)),
    ],
    resources,
  };
};

export default transformPermissionUserDetailsResponse;
